import APIRequest from './APIRequest'

class APIRequestLoader {
  post(request: APIRequest) {
    return fetch(request.url, {
      method: 'POST',
      headers: request.headers,
      body: JSON.stringify(request.data),
    })
      .then((r) => r.json())
      .then((json) => json.payload)
  }
}

export default APIRequestLoader
